<template>
    <div>
        <Breadcrumb section-name="Project" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <a class="me-2 btn btn-option mb-2" href="javascript:void(0)" @click="downloadFile">
                        <img v-if="!exportLoading" class="pdf" width="16" height="16"/>
                        <span v-if="exportLoading" class="spinner-border spinner-border-sm" role="status"
                              aria-hidden="true"></span>
                    </a>
                    <table class="table mb-0 table-striped table-bordered dataTable">
                        <thead>
                        <tr>
                            <th>Sl</th>
                            <th>Date</th>
                            <th>Particulars</th>
                            <th>Payment Method</th>
                            <th>Cash Received By</th>
                            <th class="text-end">Deposit</th>
                            <th>Remarks</th>
                        </tr>
                        </thead>
                        <tbody v-if="!loading && shareholders.length > 0">
                        <tr v-for="(each,index) in shareholders">
                            <td v-text="index + 1"></td>
                            <td>{{ each.date }}</td>
                            <td>{{ each.category_name }}</td>
                            <td>{{ each.payment_method }}</td>
                            <td>{{ each.cash_received_by }}</td>
                            <td class="text-end">{{ each.amount }}</td>
                            <td>{{ each.remarks }}</td>
                        </tr>
                        <tr>
                            <th colspan="5" class="text-end">Total</th>
                            <th class="text-end" v-text="total.total_deposit"></th>
                        </tr>
                        </tbody>
                        <tbody v-if="loading">
                        <tr>
                            <td colspan="100" class="loader-height">
                                <Loader></Loader>
                            </td>
                        </tr>
                        </tbody>
                        <tbody v-if="shareholders.length === 0">
                        <tr class="text-center">
                            <td colspan="100" class="fw-bold fs-6 text-height">
                                No Data Found
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Breadcrumb from "../Common/Breadcrumb";
import ApiService from "../../Services/ApiService";
import PrintService from "../../Services/PrintService";
import ApiRoutes from "../../Services/ApiRoutes";
import Loader from "../Common/Loader.vue";

export default {
    components: {Loader, Breadcrumb},
    data() {
        return {
            breadCrumb: [],
            shareholders: [],
            loading: false,
            total: {},
            exportLoading: false,
        }
    },
    watch: {},
    methods: {
        fetchShareholderByDate: function () {
            this.loading = true;
            ApiService.POST(ApiRoutes.Dashboard + '/fetchShareholderByDate', {
                project_id: this.$route.params.project_id,
                shareholder_id: this.$route.params.shareholder_id,
                year: this.$route.query.year ?? '',
            }, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.shareholders = res.data;
                    this.total = res.total;
                    this.breadCrumb.push(res.project_name);
                    this.breadCrumb.push(res.shareholder_name);
                }
            });
        },
        downloadFile: function () {
            PrintService.print('/print/shareholder-by-date?project_id='+this.$route.params.project_id + '&shareholder_id=' +  this.$route.params.shareholder_id);
        }
    },
    mounted() {
        this.fetchShareholderByDate();
    },
    created() {
    }
}
</script>
